import { render, staticRenderFns } from "./DynamicIT.vue?vue&type=template&id=4e9f8471"
import script from "./DynamicIT.vue?vue&type=script&lang=js"
export * from "./DynamicIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports